import dayjs from "dayjs";
import { useEffect } from "react"


const UseGetStepHookDucPage = (data: any, setActiveStep: Function, setExpired: Function,
    setExpiring: Function, setDeclined: Function, setCheckedCurrentStatus: Function) => {

    //This hook is to get the current step in the duc process to show on the stepper in the general and aian components
    useEffect(() => {
        if(data){
            setCheckedCurrentStatus(true)
            if(data?.status  === "NotSubmitted" || data?.status  === "Submitted"){
                setActiveStep(1);
            }
            if(data?.status  === "InProgress"){
                setActiveStep(2);
            }
            if(data?.status  === "InProgress" && typeof data?.dateSignedOfficial !== 'undefined'){
                setActiveStep(3);
            }
            if(data?.status === "Approved"){
                setActiveStep(4);
                const curDate = new Date();
                const expiryDay = dayjs(new Date(data?.expiresOn));
                setExpired(expiryDay.isBefore(curDate, 'day'))
                curDate.setMonth(curDate.getMonth() + 3);
                setExpiring(expiryDay.isBefore(curDate, 'day'))
                setActiveStep(4);
            }
            if(data?.status  === "Declined"){
                setDeclined(true)
                if(data?.declinedBy === "Submitter"){
                    setActiveStep(1)
                }
                else if(data?.declinedBy === "Official"){
                    setActiveStep(2)
                }
                else if(data?.declinedBy === "Committee"){
                    setActiveStep(3)
                }
            }

            if(data?.status === 'Expired'){
                setExpired(true)
            }
        }
    })

}

export default UseGetStepHookDucPage